import { getAuth, connectAuthEmulator } from "firebase/auth";

import { app } from "integrations/firebase";
import { FIREBASE_EMULATOR_AUTH_URL } from 'config';

export const auth = getAuth(app);
if (process.env.NODE_ENV === "development") {
  connectAuthEmulator(auth, FIREBASE_EMULATOR_AUTH_URL);
}
